import { useTranslation } from 'react-i18next';
import { allSettled } from 'effector';
import { useUnit } from 'effector-react';
import { MenuItem } from '@mui/material';
import { $config, createFilterToolbarScope, deleteSavedFilters } from '../../../model';
import { SavedFilter } from '../../../types';

export const DeleteItem = ({
  checkedSavedFilters,
}: {
  checkedSavedFilters: SavedFilter;
}) => {
  const { t } = useTranslation();
  const [config] = useUnit([$config]);

  const scope = createFilterToolbarScope(config!.id);

  const deleteSavedFiltersCallback = async () => {
    await allSettled(deleteSavedFilters, {
      scope,
      params: checkedSavedFilters,
    });
  };

  return (
    <MenuItem disableRipple onClick={deleteSavedFiltersCallback}>
      {t('remove')}
    </MenuItem>
  );
};
